import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Presence } from '@accounts/session';
// The shared components' tokens, styles and fonts, before this application's own theme
import '@beyond-js/ui/tokens.css';
import '@beyond-js/ui/styles.css';
import '@beyond-js/ui/fonts.css';
import { device } from '@accounts/theme';
import { App } from './app';

// First paint: this browser's copy of the language and appearance, before anything renders
device.restore();

const root = document.getElementById('root');
if (!root) throw new Error('The page has no #root element');

createRoot(root).render(
	<StrictMode>
		<BrowserRouter>
			<Presence>
				<App />
			</Presence>
		</BrowserRouter>
	</StrictMode>
);
